// removed by extract-text-webpack-plugin
module.exports = {"Home":"Home__Home__2FJrY","Title":"Home__Title__26AEM","TitleItem":"Home__TitleItem__1X5A3","TitleText":"Home__TitleText__33sVK","TitleSubButton":"Home__TitleSubButton__22Rtr","Caption":"Home__Caption__1nSD9","CaptionItem":"Home__CaptionItem__tnKJq","CaptionItemText":"Home__CaptionItemText__1oJTx","Action":"Home__Action__1-kiM","btn":"Home__btn__11nZb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 590
// module chunks = 0